import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { Container, Image  } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import Category from './Category';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import * as RIcon from "react-icons/fa"
import { Link } from 'react-router-dom';
import Payment from './Payment';
import CoinPackageList from './common/CoinPackageList';
import FollowAndNoticeButton from './common/button/FollowAndNoticeButton';

const About = () => {
    const {t,i18n} = useTranslation()
    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Header />
        <Category />
        <Container className='w-100'>
            <h4>当サイトについて</h4>
            <div className='mb-4'>
                「アワートAI」はAIを活用した作品の投稿サイトです。<br />
                クリエイター支援制度で収益化することができ、クリエイターの創作活動を支援します。<br />
                画像生成機能も基本無料です。<br />
            </div>
            <h4>{t("info.title")}</h4>
            <Link to={"/company"}>会社概要</Link><br />
            <p>{t("info.official")}：<Icon.Twitter /> <a href="https://twitter.com/ourt_ai">@ourt_ai</a></p>
            <div>{t("info.contact")}：
                <ul>
                    <li>質問・要望・バグ報告等は<a href="https://discord.gg/vQNvaCXYvu">Discord</a>または<a href="https://lin.ee/9JVODFH">LINE</a>まで</li>
                </ul>
            </div>
            <br />
            <h4>利用規約等</h4>
                <Link to="/terms">利用規約</Link><br />
                <Link to="/guideline">ガイドライン</Link><br />
                <Link to="/privacy">個人情報保護方針</Link><br />
                <Link to="/legal">特定商取引法に基づく表記</Link><br />
            <br />
            <h4>ご支援について</h4>
            <p>
                もしよろしければ、ご支援いただけるとありがたいです。<br />
                ご支援いただければ、より一層開発を加速させることができます。<br /><br />
                AI生成機能の速度向上、その他新機能の開発など・・・<br />
                ご支援の方法は、<br />
                    ・<Link to="/legal">サブスク</Link><br />
                    ・<a href="https://amzn.to/3JHlbCO" target={"_blank"} rel="noreferrer">Amazonリンク広告</a>(広告経由でのお買い物でいくらかが運営へ還元されます。)<br />
                を用意しています。<br />
            </p>
            <FollowAndNoticeButton />
            {/*<CoinPackageList coinAmount={1000} priceUSD={10} userId={"123abc"} />*/}
        </Container>
        <Footer />
    </div>
    )
}

export default About;
